import { Component, Input, EventEmitter, Output } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as turf from '@turf/turf';
import * as $ from 'jquery';
import { UserProvider } from '../../providers/user/user';
import { GeolocationProvider } from '../../providers/geolocation/geolocation';
import { PlaceServiceProvider } from '../../providers/trip-service/place-service';
import { GoogleProvider } from '../../providers/google/google';
import { TripService } from '../../providers/trip-service/trip-service';
import { ToolsProvider } from '../../providers/tools/tools';

@Component({
  selector: 'place-card',
  templateUrl: 'place-card.html',
})
export class PlaceCardComponent {
  log = debug('app:PlaceCardComponent');

  @Output() navigationStarted = new EventEmitter();
  @Input() initialSlide = null;
  @Input() places = [];
  userLocation: any = null;
  reviewStats: any = {};
  clickable = true;
  userLat: any = null;
  userLong: any = null;
  isActivePlaceTrip = false;
  loadingPlaceData = false;

  constructor(
    public userService: UserProvider,
    public geolocation: GeolocationProvider,
    public placesService: PlaceServiceProvider,
    public google: GoogleProvider,
    public tripService: TripService,
    public tools: ToolsProvider
  ) {}

  ngOnInit() {
    this.log('places: ', this.places);
  }

  ngOnChanges(changes) {
    const p = _.get(this.places, this.initialSlide);
    if (p) {
      if (p.__loadingPromise) {
        this.loadingPlaceData = true;
        p.__loadingPromise.then(
          d => {
            this.loadingPlaceData = false;
            const place = _.get(d, 'properties') || {};
            _.set(this.places, this.initialSlide, place);
            this.goToPlaceId(place && place._id);
          },
          e => {
            this.loadingPlaceData = false;
            console.error('error place not found', e);
          }
        );
      } else {
        this.goToPlaceId(p && p._id);
      }
    }
  }

  private getOtherContent() {
    const placeId = this.places[this.initialSlide]._id,
      place = this.places[this.initialSlide];
    this.getReviewStats(placeId);

    if (!place.distance) {
      this.getUsersPlacesWithMilesToUser(place);
    }
    this.getPlaceDetails();

    if (this.isStopOnTrip(place)) {
      this.isActivePlaceTrip = true;
    } else {
      this.isActivePlaceTrip = false;
    }
  }

  private goToPlaceId(placeId) {
    this.log('go to place id', placeId);
    setTimeout(() => {
      const index = _.findIndex(this.places, { _id: placeId });
      this.log('index', index);
      if (index !== -1) {
        this.initialSlide = index;
        this.getOtherContent();

        try {
          const place = this.places[index];
          this.tools.logAnalyticsEvent('trackCustom', 'place-card-view', {
            place: place._id,
          });
          this.tools.logAnalyticsEvent(
            'trackCustom',
            'place-card-view-' + place.placeType,
            {
              place: place._id,
            }
          );
        } catch (e) {}
      }
    }, 0);
  }

  private getUsersPlacesWithMilesToUser(place) {
    if (!this.userLat || !this.userLong) {
      this.geolocation.getRecentPosition().then(res => {
        this.log('geo recent location response', res);
        this.userLat = _.get(res, 'latitude');
        this.userLong = _.get(res, 'longitude');
        this.updatePlaceWithDistance(place);
      });
    } else {
      this.updatePlaceWithDistance(place);
    }
  }

  private updatePlaceWithDistance(place) {
    const placeLat: number = _.last(_.get(place, 'location.coordinates')),
      placeLong: number = _.first(_.get(place, 'location.coordinates'));

    if (placeLat && placeLong) {
      place.distance = _.round(
        turf.distance(
          turf.point([this.userLong, this.userLat]),
          turf.point([placeLong, placeLat]),
          { units: 'miles' }
        ),
        0
      );
    }
  }

  private getReviewStats(placeId) {
    this.placesService.getReviewsStatsForPlace(placeId).then(res => {
      this.reviewStats = res;
    });
  }

  private getPlaceDetails() {
    const p = this.places[this.initialSlide];

    if (p) {
      this.placesService.checkDefaultPhoto(p);
    }
  }

  navigateToDetail() {
    if (this.clickable) {
      const place = this.places[this.initialSlide];
      this.placesService.openStopDetailPageForPlace(place);
    }
  }

  navigate() {
    this.clickable = false;
    this.log('will direct to stop');
    const place = this.places[this.initialSlide];
    if (this.tripService.info.isEnroute) {
      this.tripService.addPlaceStop(place);
      this.isActivePlaceTrip = true;
    } else {
      this.tripService.navigateToPlace(place);
      this.navigationStarted.emit();
    }
    setTimeout(() => {
      this.clickable = true;
    }, 250);
  }
  removeStop() {
    this.clickable = false;
    this.log('remove stop');
    const place = this.places[this.initialSlide];
    this.tripService.removePlaceStop(place);
    this.isActivePlaceTrip = false;
    setTimeout(() => {
      this.clickable = true;
    }, 250);
  }
  private isStopOnTrip(place) {
    const trip = this.tripService.info.activeTrip,
      placeId = _.get(place, '_id');
    let isOnTrip = false;
    if (_.get(trip, 'waypoints')) {
      _.each(trip.waypoints, p => {
        if (_.get(p, '_id') === placeId) {
          isOnTrip = true;
        }
      });
    }
    return isOnTrip;
  }
}



// WEBPACK FOOTER //
// ./src/components/place-card/place-card.ts